module.exports = __webpack_public_path__ + "img/right-side-menu-outputs-active.c0aa8c55.svg";